import React, { useState } from 'react';
import './CouponDetailsModal.scss';
import CouponSuccessPopup from './CouponSuccessModal';
import { useNavigate, useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { appliedCoupon, validateCouponRequest } from '../../common/features/restaurant/restaurantAction';
import { useSelector } from 'react-redux';
import { couponClicked, toggleCartView } from '../../common/features/cart/cartActions';
import { getCookie } from '../../helper/cookieHelper';
import { USER_ID } from '../../common/constants';

const CouponDetailsModal = ({ couponDetails, open, onClose, onApply }: any) => {
  const isMobile = useSelector((state: any) => state?.navigation?.isMobile);

  const [showSuccessPopup, setShowSuccessPopup] = useState<boolean>();
  const attributes = couponDetails ? JSON.parse(couponDetails?.attributes) : null;
  const { merchantType, merchantSlug, menuType ,tableId} = useParams();
  const totals = useSelector((state: any) => state.cart.totalDetails);
  const discountAmount=totals?.orderTotals?.find((t: any) => t.code === '6')?.value;
  const slugFromLocalStorage = localStorage.getItem("restaurant") && JSON.parse(
    localStorage.getItem("restaurant") || ""
  );
  console.log({attributes});
  
  const [showSuccessPopupMobile, setShowSuccessPopupMobile] = useState<boolean>();
  const itemTotal = totals?.orderTotals?.find((t: any) => t.code === '1')?.value;
  const disabledtheApplyBtn = (Number(itemTotal)) >= Number(couponDetails?.minOrderAmount);
  const appliedCoupondata = useSelector((state: any) => state.restaurant.appliedCoupon);
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);

  const navigate = useNavigate();
  const dispatch = useDispatch();

 

const isFlatFee = couponDetails?.offerType === "FLATFEE";
const userId = getCookie(USER_ID);


const currencySymbol =
  attributes?.currencyType === "USD" ? "$" :
  attributes?.currencyType === "IN" ? "₹" : "";

const offerRate = parseFloat(couponDetails?.offerRate);

const formattedRate = isFlatFee
  ? offerRate.toFixed(2)                 // 4.00
  : Number.isInteger(offerRate)
    ? offerRate                           // 4
    : offerRate;                          // 4.5

const offerText = isFlatFee
  ? `Flat ${currencySymbol}${formattedRate} Off`
  : `${formattedRate}% Off`;
  const couponApply = () => {
    if (disabledtheApplyBtn) {
      const payload = {
        customerId: userId,
        couponCode: couponDetails?.offerCode,
        locationId: restaurantDetails?.id,
        orderTotal: itemTotal,
        couponId: couponDetails?.id,
      };
      // dispatch(appliedCoupon({ offerCode: couponSearch,id:selectedCouponId[0]?.id }));
      dispatch(validateCouponRequest(payload));
      onApply();
    }
  };
  const hasTerms=attributes?.termsAndConditions?.length>0

  if (!open) return null;

  return (
    <div className="coupon-details-overlay">
      <div className="coupon-details-modal">
        {/* Close */}
        <button className="coupon-details-modal-close-btn" onClick={onClose}>
          ✕
        </button>

        {/* Header */}
        <h3 className="coupon-code">{couponDetails?.offerCode}</h3>
        <p className="coupon-offer">
         {offerText}
        </p>

        {/* Description */}
        <p className="coupon-desc" style={{marginBottom:hasTerms?"0":"0.7rem"}}>
          Use code {couponDetails?.offerCode} & save instantly on your order. For new customers
          only.
        </p>

       {  hasTerms &&  <hr />}

        {/* Terms */}
        {
          hasTerms &&
             <div className="coupon-terms">
          <h4 className="coupon-terms-heading">Terms and conditions</h4>
          <ul className="coupon-unOrderList">
            {
              attributes?.termsAndConditions?.map((item:any)=>(
                <li className='"coupon-terms-list'>{item}</li>

              ))
            }
            {/* <li className="coupon-terms-list">This offer is personalised for you.</li>
            <li className="coupon-terms-list">
              Maximum instant discount of {attributes?.currencyType === 'USD' && '$ '}
              {attributes?.currencyType === 'IN' && '₹ '}
              {parseFloat(couponDetails?.offerRate)?.toFixed(2)}.
            </li>
            <li className="coupon-terms-list">Applicable only on select restaurants.</li>
            <li className="coupon-terms-list">
              Applicable maximum {couponDetails?.maxRedeem} times in a day.
            </li>
            <li className="coupon-terms-list">Other T&Cs may apply.</li> */}
          </ul>
        </div>

        }
      
        {/* CTA */}
        <button 
          className={`apply-btn ${(!disabledtheApplyBtn || appliedCoupondata?.id === couponDetails?.id || appliedCoupondata?.offerId === couponDetails?.id) ? 'disabled-applybtn' : ''}`} 
          onClick={couponApply}
          disabled={appliedCoupondata?.id === couponDetails?.id  || appliedCoupondata?.offerId === couponDetails?.id }
        >
          Apply
        </button>
      </div>
      {
      
         <CouponSuccessPopup
        couponDetails={couponDetails}
        open={isMobile?showSuccessPopupMobile:showSuccessPopup}
        onClose={() => {
         
         
          if (!isMobile) {
           
              // dispatch(couponClicked());
          } 
          else {
             if (tableId) {
        navigate(
          `/${slugFromLocalStorage?.merchantType}/${slugFromLocalStorage?.location}/table/${tableId}/menu/${slugFromLocalStorage?.menuType}/contactlessdinein/cart`
        );
      } else {
        navigate(`/${merchantType}/${merchantSlug}/cart`);
      }
          }
        }}
      />
      }
     
    </div>
  );
};

export default CouponDetailsModal;
